import { jsx as _jsx } from "react/jsx-runtime";
import { getPageControls, } from '@tymia/shared';
import React, {} from 'react';
import { Link, } from 'react-router-dom';
export function Pagination({ currentPage, totalPages, getPageDefinition, }) {
    const pages = getPageControls({
        page: currentPage,
        totalPages,
        maxPages: 7,
    });
    return (_jsx("div", { className: "flex justify-center items-center py-8 m-0 flex-wrap max-w-full overflow-x-auto", children: pages.map((page, index) => {
            if (page.type === '...') {
                return (_jsx("span", { className: "px-2 py-0.5 m-1 text-gray-400 text-sm sm:text-base", children: "..." }, index));
            }
            const { href, onClick } = getPageDefinition(page.page);
            return (_jsx(Link, { to: href, onClick: onClick, className: `px-2 py-0.5 m-1 rounded-md border border-gray-300 text-sm sm:text-base ${page.page === currentPage
                    ? 'bg-tym-green text-white border-tym-green'
                    : 'text-gray-600 hover:bg-gray-100'}`, children: { previous: 'ᐊ', next: 'ᐅ', page: page.page }[page.type] }, index));
        }) }));
}
//# sourceMappingURL=Pagination.js.map